<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7588 26.7039C15.9137 26.844 13.9553 27.1115 11.6668 27.5L5.59082 15.8303C17.3256 11.4326 23.8543 11.3474 35.5908 15.8303L29.5149 27.5C25.3645 26.759 22.2999 26.481 19.028 26.6271L13.2993 17.0984L12.3127 17.6454L17.7588 26.7039ZM25.7174 15.4175C25.7174 15.4175 26.6333 16.7243 27.3043 17.9816C27.3665 18.1194 27.4388 18.2615 27.5128 18.4067C27.7463 18.8654 27.9959 19.3557 27.9959 19.8437C27.9959 21.0241 26.9763 21.9817 25.7174 21.9817C24.4594 21.9817 23.4389 21.0241 23.4389 19.8437C23.4389 19.1277 23.8649 18.4069 24.252 17.752C24.3436 17.597 24.433 17.4457 24.5141 17.299C25.104 16.2928 25.7174 15.4175 25.7174 15.4175Z"
      class="fill-current"
    />
  </svg>
</template>
